<template>
    <vx-card id="packs">
      
      <div id="">
        <span class="title-style modify-title" style="display:inline-block; margin-bottom:8px">Responsabilidad Civil - Médicos. </span>
        <span class="subtitle-style modify-subtitle" style="display:inline-block; opacity: 0.7;">Este seguro te protege ante posibles reclamaciones por daños a terceros en tu actividad <b>{{getActivityType()}}</b>, especialidad <b>{{getSpecialty()}}</b>.
          Elige la opción que consideres. </span>

        <div class="vx-card" v-if="commercialOffer">
          <div class="vx-row pack">
            <div class="vs-col md:w-1/3 p-4"  :key="'b'+indexDetail" v-for="(pack, indexDetail) in commercialOffer" >
              <div class="vx-card bg-box-gradient table-test p-1" :id="changeTableId(indexDetail)"> <!-- -->
                <div class="pb-2 pt-1" :id="changeImageId(indexDetail)">
                    <img src="../../../../assets/images/pages/eCommerce/umbrella.png">
                      <span class="packName">{{changePackName(indexDetail)}}</span><br>
                      <span class="packPrima">{{decimalNumberWithCommas(pack.priceMonth.toFixed(2))}}</span>
                      <span class="packUnits"> €/año</span>
                </div>
                <div >
                  <div class="vx-card mt-2 p-2">
                     <div class="pb-3">
                      <ul class="listCoverCategory" >
                        <li>
                          <span class="categoryName">Por siniestro,</span>
                          <span class="categoryDetail"> hasta: </span>
                          <span class="categoryCapital">{{formatImporte(pack.capitalToCover)}}</span><br>
                          <span class="categoryName"> Doble capital por anualidad de seguro. </span>
                        </li>
                        <li>
                          <span class="categoryName">Cobertura "integral" de la responsabilidad civil: RC Profesional, RC Explotación y RC Patronal.</span>
                        </li>
                        <li>
                          <span class="categoryName">Defensa civil y finanzas.</span>
                        </li>
                        <li>
                          <span class="categoryName">Inhabilitación profesional</span>
                        </li>
                        <li>
                          <span class="categoryName">Delimitacion temporal: Claims made retroactividad ilimitada.</span>
                        </li>
                      </ul>
                     </div>
                  </div>
                </div>
                <div class="info-interested-div">
                <!-- Important the order of buttons, as direction is row-reverse: izq a dcha 
                To avoid movement of buttons when i button not showed  -->
                    <vs-button
                      class="rounded-button right-button-pack"
                      @click="goToThirdStep(pack, changePackName(indexDetail))"
                      >
                      Me interesa
                    </vs-button>
                    <vs-button
                      class="info-button"
                      @click="showCoverageChart(indexDetail)">
                        &#9432;
                    </vs-button>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div>
            <span> <a @click="openFile()" >Documento informativo del producto</a></span>
        </div>
        <div v-if="packCoverageChart">

            <vs-popup class="con-vs-popup coverage-popup" id="coverage-popup" :active.sync="coverageChartPop">
            <!-- <vs-popup  class="con-vs-popup"  :title="makeTitle(packCoverageChart.name, dataTablePackage[0].receipt)" :active.sync="coverageChartPop"> -->
              <coverage-chart-component
                  v-bind:coverageChart="packCoverageChart"
                  v-bind:dataTable="dataTablePackage"
                  v-bind:coverageChartPop="coverageChartPop"
                  @closeCoverageChartPop="closeCoverageChartPop"
              ></coverage-chart-component>
            </vs-popup>
          </div>
          
          <navegation-buttons id= "buttons"
              v-bind:code="code"
              v-bind:previus="previus"
              >
          </navegation-buttons>
    </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../../../components/vx-card/VxCard.vue'
import CoverageChartComponent from '../coverage-chart/CoverageChartComponent.vue'
import vSelect from 'vue-select'
import NavegationButtons from '../navegationButtons/NavegationButtons.vue';
import CallServicePopup from '../callServicePopup/CallServicePopup.vue';

export default {
  
  name: 'civil-liability-packs',
  props: {
      commercialOffer: Array,
      code: String,
      next: String,
      previus: String,
  },
  components: {
      VxCard,
      CallServicePopup,
      CoverageChartComponent,
      NavegationButtons
    },
    data() {
      return {
        step: 2,
        dataStored: null,
        dataTablePackage: [],
        packsCoverageChart: null,
        packCoverageChart: null,
        coverageChartPop: false,
      }
    },
    created() {
      this.$vs.loading.close()

  
      this.dataStored = JSON.parse(localStorage.getItem(this.code))
      // console.log(this.code)
      //this.chargeInfo()
      this.getCoverageChart()
      
    },
  	methods: {
      chargeInfo() {
        switch(this.dataStored.initialData.activityType) {
          case "public":
            this.commercialOffer = this.dataStored.offer[0].publicCivilLiabilities
            break;
          case "mixed":
            this.commercialOffer = this.dataStored.offer[0].mixedCivilLiabilities
            break;
          case "private":
            this.commercialOffer = this.dataStored.offer[0].privateCivilLiabilities
            break;
        }
      }, 
      getCoverageChart() {
        let params = {
          type: "RC",
          coverPacks: []
        }

        for (let i = 0; i < this.commercialOffer.length; i ++){
          
          let item = {
            packName: this.changePackName(i),
            capital: this.commercialOffer[i].capitalToCover
          }

          item.capital = parseInt(item.capital)

          params.coverPacks.push(item)
        }

        this.$http.post(process.env.VUE_APP_BROKER_API + '/ext-prod-cover-chart/'+ this.dataStored.extraProduct._id, params)
        .then((response) => {
            this.packsCoverageChart = response.data;

            this.dataStored.packsCoverageChart = this.packsCoverageChart

        })
      },
        getSpecialty() {
          return this.dataStored.initialData.profession.toLowerCase()
        },

       getActivityType() {
         let response
        switch(this.dataStored.initialData.activityType) {
          case "public":
            response = "pública"
            break;
          case "mixed":
            response = "mixta"
            break;
          case "private":
            response = "privada"
            break;
        }

        return response
      },
      formatImporte(importe){
        if(!isNaN(importe)){
          return Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(importe.toFixed(2));
        }
        
        return importe;
      },
      changeTableId(indexDetail){
        return 'pack-'+indexDetail
      },
      changeImageId(indexDetail){
        return 'image-'+indexDetail
      },
      
      openFile(){
        var windowFileReference = window.open();

        this.$http.get(process.env.VUE_APP_BROKER_API + "/files/61bafd03b8f3f70ec8d87669")
          .then((response) => {
            // Changed as the window.open was blocked in IOS 
            windowFileReference.location = response.data.fileRoute;
                    
            // window.open(response.data.fileRoute, '_blank');
          })
      },
      
      goToThirdStep(pack, packName) {

        this.$vs.loading({ type: "sound" });

        this.dataStored.filesToSign = this.dataStored.extraProduct.requestId

        this.dataStored.pack = pack
        localStorage.setItem(this.code, JSON.stringify(this.dataStored))

        let params = {
          extraProductCode: this.code,
          medialSpecialty: this.dataStored.initialData.profession,
          activityType: this.dataStored.initialData.activityType,
          packName: packName,
          primaNeta: parseFloat(pack.priceMonth),
          capitalToCover: parseFloat(pack.capitalToCover),
          leadType:"CivilLiability"
        }

        // var windowReference = window.open();

        this.$http.patch(process.env.VUE_APP_BROKER_API + '/initial-data/' + this.dataStored.initialData.initialDataId, params)
        .then((response) => {

          // this.closeLoader = setInterval(async () => {
          //   this.localDataStored = JSON.parse(localStorage.getItem(this.code))
          //   if (this.localDataStored.signed == true)  {
          //       // Delete localStorage 
          //       localStorage.removeItem(this.code);

          //       this.$vs.loading.close()
          //       clearInterval(this.closeLoader)
          //       this.$router
          //           .push("/extra-products/" +  this.code)
          //           .catch(() => {});
          //   }

          // }, 15000)
          // Changed as the window.open was blocked in IOS 
          // windowReference.location = process.env.VUE_APP_DOMAIN + '/' + this.next + '-step/' + this.code;
          
          this.$router
          .push("/" + this.next + "-step/" + this.code)
          .catch(() => {});

          // window.open(process.env.VUE_APP_DOMAIN + "/" + this.next + "-step/" + this.code, '_blank');

        })
      },
      showCoverageChart(indexDetail){
        this.showPackageDetail(this.changePackName(indexDetail), indexDetail);
        this.coverageChartPop = true;
      },
      showPackageDetail(packName, indexDetail) {
            this.dataTablePackage = [];
            this.packCoverageChart = this.packsCoverageChart.packOffer.filter(x => x.name == packName)[0]
           let itemTable = {
             name: packName,
             receipt: this.commercialOffer[indexDetail].priceMonth,
             paymentMethod: 1
           }
           this.dataTablePackage.push( itemTable)
            let params = {
              packIndex: "",
              paymentMethod: ""
            }
            params.packIndex = indexDetail
            params.paymentMethod = 1
            this.dataTablePackage.push(params)

       },
       closeCoverageChartPop(value){
          this.coverageChartPop = value.closePop;
          if (value.packName != "") {
            let response;
            switch (value.packName) {
              case "Esencial":
                  response = 0
                break
              case "Moderada": 
                  response = 1
                break
              case "Superior":
                  response = 2
              break
            }

            this.goToThirdStep(this.commercialOffer[response], value.packName)
          }  else{
            return true
          }
        },
      changePackName(index) {
        let response 
        switch (index) {
          case 0:
              response = "Esencial"
            break
          case 1: 
              response = "Moderada"
            break
          case 2:
              response = "Superior"
            break
        }

        return response
      },
      decimalNumberWithCommas(number) {
          if(number){
            let decimalCommaNumber = number.replace('.',',')
            return decimalCommaNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          }
        },
    }
}
</script>

 <style lang="scss">
 #rc-style {
   .modify-subtitle {
     text-align:left !important
   }
 }
.listCoverCategory {
  list-style-position: outside !important;
  list-style: disc;
  text-align: left;
  padding-left: 20px;
}

.listCoverCategory li {
  padding-bottom: 5px;
}
#packs {

    .align{
          display: flex;
          align-items: center !important;
          justify-content: space-between;
      }

    // .more-info{
    //   font-style: normal;
    //   font-size:25px !important;
    //   float: left !important;
    //   margin-left: 10px;
    //   color:rgba(var(--vs-secundary), 1) !important;
    //   opacity: 1;
    //   font-weight:bold;
    //   cursor: pointer;
    //   // padding: 0px !important;
    //   border: none !important;
    //   // padding-bottom: 15px !important;

    // :hover {
    //   font-size:28px !important;
    //   }
    // }
    #pack-0 {
      border: 2px solid #FFCDD2 !important;
    }
    #pack-1 {
      border: 2px solid #EF9A9A !important;
    }
    #pack-2 {
      border: 2px solid #E57373 !important;
    }

    #image-0 {
      img{
        width: 50px;
        height: 50px;
        display:block;
        margin:auto;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
    #image-1 {
      img{
        width: 60px;
        height: 60px;
        display:block;
        margin:auto;
        margin-top: 5px;
        margin-bottom: 5px;
      }
    }

    #image-2 {
      img{
        width: 70px;
        height: 70px;
        display:block;
        margin:auto;
      }
    }

      #buttons .next-button {
        display: none;
      }
  }

  .table-test {
    background: none !important;
    border-radius: 10%;
    display: inline-block;
    width: fit-content;
  }

  .categoryCapital{
    white-space:nowrap;
  }


  @media(max-width: 760px) {

    #packs {

      .packName{
        font-size: 17px;
      }

        .router-content {
          margin-top: -0.5rem !important;
        }

        .pack {
          margin-left: auto;
          margin-right: auto;
          .vs-col {
            width: 100% !important;
            }

          }

    }
  }

  @media only screen and (min-width : 600px)
    and (max-width : 760px) {
    #packs {

      .packName{
        font-size: 17px;
      }

      #buttons .call-button {
        float: right;
      }

      .pack {
          margin-left: 10%;
          margin-right: 10%;

          .vs-col .vs-col {
            width: 100%;
          }

        }

      }
    }

  @media(min-width: 761px) {

    #packs {

      .packName{
        font-size: 18px;
      }

        .pack {
          margin-left: auto;
          margin-right: auto;

          .vs-col .vs-col {
            width: 100%;
          }

        }

      #buttons .call-button button{
        float:right;

      }
      }
  }

  @media(max-width: 959px) {
  }

</style>